<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 选项卡 -->
    <div class="topSelect mgb-30">
      <div
        :class="topSelectActive == v.id ? 'divActive' : 'div'"
        v-for="v in topSelect"
        :key="v.id"
        @click="topSelectChange(v)"
      >
        {{ v.name }}
      </div>
    </div>

    <!-- 查询表单 -->
    <div class="bg-white pdb-10 pdt-10">
      <el-form inline ref="lookForm" :model="lookForm" label-width="80px">
        <el-form-item label="套餐名称">
          <el-input
            v-model="lookForm.name"
            clearable
            placeholder="请输入套餐名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="套餐状态">
          <el-select v-model="lookForm.state" placeholder="全部" clearable>
            <el-option label="上架中" value="true"></el-option>
            <el-option label="已下架" value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属分区">
          <el-select
            filterable
            v-model="lookForm.fenqu"
            placeholder="全部"
            clearable
          >
            <el-option
              v-for="(v, i) in zoneArr"
              :key="i"
              :label="v.regionName"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="水卡类型">
          <el-select v-model="lookForm.cardType" clearable placeholder="全部">
            <el-option label="实物卡" value="2"></el-option>
            <el-option label="电子卡" value="1"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="新增时间">
          <el-date-picker
            v-model="lookForm.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="lookForm.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <br />
        <el-form-item v-if="topSelectActive === 7" style="margin-left: 10px">
          <el-button type="primary" @click="WirthMD()">白名单</el-button>
        </el-form-item>
      </el-form>
    </div>
    <btns @exec="exec" class="mgb-20"></btns>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%"
      :cell-style="cellStayle"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="套餐名称"> </el-table-column>
      <!-- <el-table-column prop="name" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.type === 1
                ? '电子卡'
                : scope.row.type === 2
                ? '实物卡'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="outDay" label="套餐类型">
        <template slot-scope="scope">
          <span v-text="scope.row.outDay ? '限时套餐' : '普通套餐'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="outDay" label="所属分区">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="
              fenquVisible = true;
              suoshu = scope.row.regionName;
            "
            >查看</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="outDay" label="有效时长">
        <template slot-scope="scope">
          <span
            v-text="scope.row.outDay ? scope.row.outDay + '天' : '不限天数'"
          ></span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="sceneIdStr" label="生效场景">
        <template slot-scope="scope">
          <span
            v-text="scope.row.sceneIdStr ? scope.row.sceneIdStr : '- -'"
          ></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="payPrice" label="支付金额（元）">
      </el-table-column>
      <el-table-column prop="orderPrice" label="实际到账（元）">
      </el-table-column>
      <el-table-column prop="unitPrice" label="每桶水金额（元）">
      </el-table-column>
      <el-table-column prop="buyedNum" label="已充值次数"> </el-table-column>
      <el-table-column prop="beUseNum" label="可充值次数">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.beUseNum == null ? '不限次数' : scope.row.beUseNum
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="userNum" label="同一用户可充值次数">
        <template slot-scope="scope">
          <span
            v-text="scope.row.userNum == null ? '不限次数' : scope.row.userNum"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序"> </el-table-column>
      <el-table-column prop="state" label="状态">
        <template slot-scope="scope">
          <span v-text="scope.row.state ? '上架中' : '已下架'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="state" label="审核状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.examine === 2
                ? '已通过'
                : scope.row.examine === 1
                ? '审核中'
                : '已驳回'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="添加时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleLook(scope.row)"
            >查看</el-button
          >
          <el-button
            v-if="scope.row.examine !== 1"
            type="text"
            size="small"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="roleId !== 23"
            type="text"
            size="small"
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 所属分区弹框 -->
    <el-dialog
      title="所属分区"
      :visible.sync="fenquVisible"
      width="30%"
      top="30vh"
      center
    >
      <div>{{ suoshu ? suoshu : "该套餐未划分区" }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fenquVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <!-- 查看弹框 -->
    <el-dialog
      title="查看套餐详情"
      :visible.sync="lookVisible"
      width="50%"
      :close-on-click-modal="false"
      center
    >
      <el-descriptions :column="1" border>
        <el-descriptions-item label="套餐名称">{{
          lookVisibleForm.name
        }}</el-descriptions-item>
        <!-- <el-descriptions-item label="水卡类型">{{
          lookVisibleForm.type === 1 ? "电子卡" : "实物卡"
        }}</el-descriptions-item> -->
        <el-descriptions-item label="时效类型">{{
          lookVisibleForm.outDay ? "限时套餐" : "普通套餐"
        }}</el-descriptions-item>
        <el-descriptions-item label="所属分区">{{
          lookVisibleForm.regionName
        }}</el-descriptions-item>
        <el-descriptions-item label="有效时长">{{
          lookVisibleForm.outDay ? lookVisibleForm.outDay + "天" : "不限天数"
        }}</el-descriptions-item>
        <!-- <el-descriptions-item v-if="topSelectActive == 1" label="生效场景">{{
          lookVisibleForm.sceneIdStr
        }}</el-descriptions-item> -->
        <el-descriptions-item label="充值金额（元）">{{
          lookVisibleForm.payPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送金额（元）">{{
          lookVisibleForm.givePrice
        }}</el-descriptions-item>
        <el-descriptions-item label="首充合伙人分润金额（元）">{{
          lookVisibleForm.cardBindingBonusPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="实际到账金额（元）">{{
          lookVisibleForm.orderPrice
        }}</el-descriptions-item>
        <el-descriptions-item label="已充值次数">{{
          lookVisibleForm.buyedNum
        }}</el-descriptions-item>
        <el-descriptions-item label="同一用户可充值次数">{{
          lookVisibleForm.userNum
        }}</el-descriptions-item>
        <el-descriptions-item label="可充值次数">
          <span
            v-text="
              lookVisibleForm.beUseNum == null
                ? '不限次数'
                : lookVisibleForm.beUseNum
            "
          ></span>
        </el-descriptions-item>
        <el-descriptions-item label="排序">{{
          lookVisibleForm.sort
        }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <span v-text="lookVisibleForm.state ? '上架中' : '已下架'"></span>
        </el-descriptions-item>
        <el-descriptions-item label="添加时间">{{
          lookVisibleForm.createTime
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookVisible = false">已 知 晓</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="type === 1 ? '新增' : '编辑'"
      :visible.sync="AddOREditVisible"
      width="30%"
      :close-on-click-modal="false"
      center
      @close="close"
    >
      <el-form
        ref="addEditForm"
        :model="addEditForm"
        label-width="140px"
        :rules="addEditFormRules"
      >
        <el-form-item label="套餐名称" prop="name">
          <el-input
            :disabled="isDis"
            v-model="addEditForm.name"
            placeholder="请输入套餐名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="水卡类型"
          prop="cardType"
          v-if="topSelectActive == 1"
        >
          <el-select
            :disabled="type == 2"
            v-model="addEditForm.cardType"
            placeholder="请选择充值水卡类型"
          >
            <el-option label="实物卡" value="2"></el-option>
            <el-option label="电子卡" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="套餐类型" prop="timeType">
          <el-select
            :disabled="isDis"
            v-model="addEditForm.timeType"
            placeholder="请选择套餐类型"
          >
            <!-- <el-option label="限时套餐" value="限时套餐"></el-option> -->
            <el-option label="普通套餐" value="普通套餐"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item
          label="有效周期"
          prop="period"
          v-if="addEditForm.timeType == '限时套餐'"
        >
          <el-radio-group
            :disabled="isDis"
            @input="periodChange"
            v-model="addEditForm.period"
          >
            <el-radio label="周套餐"></el-radio>
            <el-radio label="月套餐"></el-radio>
            <el-radio label="季套餐"></el-radio>
            <el-radio label="年套餐"></el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item
          prop="outDay"
          label="有效时长"
          v-if="addEditForm.timeType == '限时套餐'"
        >
          <el-input
            v-model="addEditForm.outDay"
            placeholder="请输入套餐有效时长"
          >
            <template slot="append">天</template>
          </el-input>
          <span class="colorred"
            >*有效时长计算方式：自用户购买日生效，按自然日连续计算。</span
          >
        </el-form-item>
        <el-form-item label="支付金额" prop="payPrice">
          <el-input
            :disabled="isDis"
            v-model="addEditForm.payPrice"
            placeholder="请输入套餐价格"
            @input="payPriceInput"
            :controls="false"
          ></el-input>
        </el-form-item>
        <el-form-item label="赠送金额" prop="givePrice">
          <el-input
            :disabled="isDis"
            v-model="addEditForm.givePrice"
            placeholder="请输入赠送金额"
            @input="givePriceInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="首充合伙人分润金额" prop="cardBindingBonusPrice">
          <el-input
            :disabled="isDis"
            v-model="addEditForm.cardBindingBonusPrice"
            placeholder="请输入首充合伙人分润金额"
            @input="cardBindingBonusPriceInput"
          ></el-input>
        </el-form-item>
        <el-form-item label="实际到账">
          <el-input
            v-model="addEditForm.actualPrice"
            :disabled="true"
          ></el-input>
          <span class="colorred">*实际到账金额需≤5000元。</span>
        </el-form-item>
        <el-form-item label="纯净水参考价格" prop="consultPrice">
          <el-input
            v-model="addEditForm.consultPrice"
            placeholder="请输入参考价格"
            @input="consultPriceInput"
          >
            <template slot="append">元/1000ml</template>
          </el-input>
        </el-form-item>

        <el-form-item label="每桶水的金额">
          <el-input
            :disabled="true"
            v-model="addEditForm.unitPrice"
            placeholder="每桶纯净水的金额(系统自动计算)"
          ></el-input>
        </el-form-item>
        <el-form-item label="可充值次数" prop="beUseNum" v-if="![3].includes(topSelectActive)">
          <el-input
            :disabled="isDis"
            v-model="addEditForm.beUseNum"
            placeholder="请输入充值次数"
          ></el-input>
          <span class="colorred"
            >*超过限制次数该套餐将自动下架，不填写默认为不限次数。</span
          >
        </el-form-item>
        <el-form-item label="同一用户可充值次数" prop="userNum" v-if="![3].includes(topSelectActive)">
          <el-input
            :disabled="isDis"
            v-model="addEditForm.userNum"
            placeholder="请输入充值次数"
          ></el-input>
          <span class="colorred"
            >*超过限制次数该套餐将自动下架，不填写默认为不限次数。</span
          >
        </el-form-item>
        <el-form-item label="套餐排序" prop="sort">
          <el-input
            v-model="addEditForm.sort"
            placeholder="数字越大，排序越靠前"
          ></el-input>
        </el-form-item>
        <el-form-item label="套餐状态" prop="state" v-if="isState">
          <el-select v-model="addEditForm.state" placeholder="请选择套餐状态">
            <el-option label="上架" value="true"></el-option>
            <el-option label="下架" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="驳回原因" v-if="isYuan == 1">
          <el-input
            disabled
            type="textarea"
            v-model="addEditForm.failMessage"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="AddOREditVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="sure('addEditForm')">{{
          btnContent
        }}</el-button>
      </span>
    </el-dialog>

    <whitelistDialog ref="whitelistDialog"></whitelistDialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";
import whitelistDialog from "./whitelistDialog.vue";
export default {
  components: {
    breadcrumbs,
    btns,
    whitelistDialog
  },
  props: {
    defaultTopSelectActive: {
      type: Number | String
    },
    defaultTopSelect: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const addname = (rule, value, callback) => {
      var reg = /^[0-9_\u4e00-\u9fa5]{1,10}$/;
      if (!value) {
        callback(new Error("请填写套餐名称"));
      } else if (value.length > 15) {
        callback(new Error("仅支持15字内文字输入，请重新输入"));
      } else {
        callback();
      }
    };
    const addduration = (rule, value, callback) => {
      var reg = /^(?:[1-9]|[1-9]\d|1\d{2}|2[0-9]{2}|3[0-5]{2}|36[0-5])$/;
      if (value && !reg.test(value)) {
        callback(new Error("仅支持输入1-365之间的正整数"));
      } else {
        callback();
      }
    };
    const addpayPrice = (rule, value, callback) => {
      var reg = /^\d{0,7}(\.\d{0,2})?$/g;
      if (!value) {
        callback(new Error("请填写充值金额"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持数字数输入，最多7位，小数点后仅支持2位"));
      } else {
        callback();
      }
    };

    const addpayPrice2 = (rule, value, callback) => {
      var reg = /^\d{0,7}(\.\d{0,2})?$/g;
      if (!value) {
        callback(new Error("请填写每桶水的金额"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持数字数输入，最多7位，小数点后仅支持2位"));
      } else {
        callback();
      }
    };

    const addgivePrice = (rule, value, callback) => {
      // var reg = /^\d{0,7}(\.\d{0,2})?$/g;
      var reg = /^(0|[1-9]\d{0,3})$/;
      if (!reg.test(value)) {
        callback(new Error("仅支持数字数输入，最多4位，不支持小数"));
      } else {
        callback();
      }
    };
    const addbeUseNum = (rule, value, callback) => {
      var reg = /^[1-9]\d{0,4}$/;
      if (value && !reg.test(value)) {
        callback(new Error("仅支持数字，最多五位，且首个不为0"));
      } else {
        callback();
      }
    };
    const addsort = (rule, value, callback) => {
      var reg = /^[1-9]\d{0,2}$/g;
      if (!value) {
        callback(new Error("请填写排序"));
      } else if (!reg.test(value)) {
        callback(new Error("仅支持数字，最多三位，且首个不为0"));
      } else {
        callback();
      }
    };
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.lookForm.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },

      lookForm: {}, //查询表单
      tableData: [], //套餐列表表格
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      lookVisible: false,
      suoshu: null,
      fenquVisible: false,
      lookVisibleForm: {},
      type: null, //1为新增，2为编辑
      AddOREditVisible: false,
      isState: false,
      isYuan: null,
      isDis: null,
      addEditForm: {
        actualPrice: 0
      },
      addEditFormRules: {
        sceneId: [
          { required: true, message: "请选择生效场景", trigger: "change" }
        ],
        state: [
          { required: true, message: "请选择套餐状态", trigger: "change" }
        ],
        cardType: [
          { required: true, message: "请选择充值水卡类型", trigger: "change" }
        ],
        name: [{ required: true, validator: addname, trigger: "change" }],
        payPrice: [
          { required: true, validator: addpayPrice, trigger: "change" }
        ],
        givePrice: [
          { required: true, validator: addgivePrice, trigger: "change" }
        ],
        consultPrice: [
          { required: true, message: "请输入参考价格", trigger: "change" }
        ],
        beUseNum: [
          { required: false, validator: addbeUseNum, trigger: "change" }
        ],
        userNum: [
          { required: false, validator: addbeUseNum, trigger: "change" }
        ],
        sort: [{ required: true, validator: addsort, trigger: "change" }],
        companyId: [
          { required: true, message: "请选择所属企业", trigger: "change" }
        ],
        unitPrice: [
          { required: true, validator: addpayPrice2, trigger: "change" }
        ],
        outDay: [{ required: true, validator: addduration, trigger: "change" }],
        period: [
          { required: true, message: "请选择时效周期", trigger: "change" }
        ],
        timeType: [
          { required: true, message: "请选择时效类型", trigger: "change" }
        ]
      },
      id: null, //套餐id
      topSelect: [
        { id: 1, name: "用户水卡套餐" },
        { id: 2, name: "活动水卡套餐" },
        { id: 7, name: "小程序活动水卡套餐" },

        // { id: 3, name: "合伙人充值套餐" }
      ],
      topSelectActive: 1,
      roleId: null,
      companyIdArr: [],
      companyName: null,
      btnContent: "",
      zoneArr: []
    };
  },
  watch: {
    "lookForm.startTime"() {
      if (this.lookForm.startTime == null) {
        this.lookForm.endTime = null;
      }
    },
    defaultTopSelectActive: {
      immediate: true,
      handler(v) {
        if (v) {
          this.topSelectActive = v;
          this.getList();
          this.getROLE();
          this.getZone();
        }
      }
    },
    defaultTopSelect: {
      deep: true,
      immediate: true,
      handler(v) {
        if (Array.isArray(v) && v.length > 0) {
          this.topSelect = this.topSelect.filter(item => v.includes(item.id));
          this.getList();
          this.getROLE();
          this.getZone();
        }
      }
    }
  },
  created() {
    this.getList();
    this.getROLE();
    this.getZone();
  },
  methods: {
    WirthMD() {
      this.$refs.whitelistDialog.openDialog();
    },
    getZone() {
      this.$api.marketing.allZonePull().then(res => {
        console.log(res, "分区下拉");
        if (res.code === 200) {
          this.zoneArr = res.data;
        }
      });
    },
    // 有效周期选择
    periodChange(e) {
      if (e == "周套餐") {
        this.addEditForm.outDay = 7;
      } else if (e == "月套餐") {
        this.addEditForm.outDay = 30;
      } else if (e == "季套餐") {
        this.addEditForm.outDay = 90;
      } else if (e == "年套餐") {
        this.addEditForm.outDay = 365;
      }
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },
    topSelectChange(v) {
      this.topSelectActive = v.id;
      this.lookForm = {};
      this.getList();
    },
    // 充值套餐列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      let arr = null;
      if (this.lookForm.fenqu) {
        arr = "(" + this.lookForm.fenqu + ")";
      }
      this.$api.marketing
        .topList({
          pageNum: this.page,
          pageSize: this.pageSize,
          endTime: this.lookForm.endTime,
          startTime: this.lookForm.startTime,
          name: this.lookForm.name,
          state: this.lookForm.state,
          cardType:
            this.topSelectActive == 1
              ? 1
              : this.topSelectActive == 2
              ? 2
              : this.topSelectActive == 7
              ? 7
              : 3,
          companyId: this.lookForm.companyId,
          regionId: arr
          // type: this.lookForm.cardType,
        })
        .then(res => {
          if (res.code === 200) {
            this.total = res.data.total;
            res.data.rows.forEach(v => {
              if (v.sceneId) {
                v.sceneIdStr = v.sceneId
                  .split(",")
                  .map(data => {
                    return data == 1
                      ? "景区场景"
                      : data == 2
                      ? "校园场景"
                      : data == 3
                      ? "社区场景"
                      : "";
                  })
                  .toString("/");
              }
            });
            this.tableData = res.data.rows;
          }
        });
    },

    // actualPriceBlur() {
    //   this.addEditForm.actualPrice =
    //     this.addEditForm.payPrice + this.addEditForm.givePrice;
    // },
    payPriceInput() {
      this.addEditForm.payPrice = this.addEditForm.payPrice.match(
        /\d+(\.\d{0,2})?/
      )
        ? this.addEditForm.payPrice.match(/\d+(\.\d{0,2})?/)[0]
        : "";
      this.addEditForm.actualPrice =
        Number(this.addEditForm.payPrice || 0) +
        Number(this.addEditForm.givePrice || 0);

      if (this.addEditForm.actualPrice && this.addEditForm.consultPrice) {
        let unitPrice =
          this.addEditForm.payPrice /
          (this.addEditForm.actualPrice / this.addEditForm.consultPrice / 7.5);
        this.addEditForm.unitPrice = unitPrice.toFixed(2);
      }
    },
    givePriceInput() {
      this.addEditForm.givePrice = this.addEditForm.givePrice.match(
        /\d+(\.\d{0,2})?/
      )
        ? this.addEditForm.givePrice.match(/\d+(\.\d{0,2})?/)[0]
        : "";
      this.addEditForm.actualPrice =
        Number(this.addEditForm.payPrice || 0) +
        Number(this.addEditForm.givePrice || 0);
      if (this.addEditForm.actualPrice && this.addEditForm.consultPrice) {
        let unitPrice =
          this.addEditForm.payPrice /
          (this.addEditForm.actualPrice / this.addEditForm.consultPrice / 7.5);
        this.addEditForm.unitPrice = unitPrice.toFixed(2);
      }
    },
    cardBindingBonusPriceInput() {
      this.addEditForm.cardBindingBonusPrice = this.addEditForm.cardBindingBonusPrice.match(
        /\d+(\.\d{0,2})?/
      )
        ? this.addEditForm.cardBindingBonusPrice.match(/\d+(\.\d{0,2})?/)[0]
        : "";
      this.addEditForm.actualPrice =
        Number(this.addEditForm.payPrice || 0) +
        Number(this.addEditForm.givePrice || 0);
      if (this.addEditForm.actualPrice && this.addEditForm.consultPrice) {
        let unitPrice =
          this.addEditForm.payPrice /
          (this.addEditForm.actualPrice / this.addEditForm.consultPrice / 7.5);
        this.addEditForm.unitPrice = unitPrice.toFixed(2);
      }
    },

    consultPriceInput() {
      this.addEditForm.consultPrice = this.addEditForm.consultPrice.match(
        /\d+(\.\d{0,2})?/
      )
        ? this.addEditForm.consultPrice.match(/\d+(\.\d{0,2})?/)[0]
        : "";
      if (this.addEditForm.actualPrice && this.addEditForm.consultPrice) {
        let unitPrice =
          this.addEditForm.payPrice /
          (this.addEditForm.actualPrice / this.addEditForm.consultPrice / 7.5);
        this.addEditForm.unitPrice = unitPrice.toFixed(2);
      }
    },

    // addSum(a) {
    //   this.addEditForm.actualPrice =
    //     this.MathAdd(this.addEditForm.payPrice) +
    //     this.MathAdd(this.addEditForm.givePrice);
    // },
    // MathAdd(a, b) {
    //   var c, d, e;
    //   try {
    //     c = a.toString().split(".")[1].length;
    //   } catch (f) {
    //     c = 0;
    //   }
    //   try {
    //     d = b.toString().split(".")[1].length;
    //   } catch (f) {
    //     d = 0;
    //   }
    //   return (e = Math.pow(10, Math.max(c, d))), (mul(a, e) + mul(b, e)) / e;
    // },

    // 根据条件判断字段颜色
    cellStayle(row, colum, rowIndex, columnIndex) {
      if (row.row.examine === 2 && row.columnIndex == 13) {
        return "color:green";
      } else if (row.row.examine === 1 && row.columnIndex == 13) {
        return "color:orange";
      } else if (row.row.examine === 3 && row.columnIndex == 13) {
        return "color:red";
      } else {
        return;
      }
    },

    // 表格查看
    handleLook(row) {
      this.lookVisible = true;
      this.lookVisibleForm = row;
    },

    // 删除
    handleDel(row) {
      if (row.state === true) {
        handleAlert("上架的套餐不支持删除", "error");
        return;
      }
      handleConfirm("确认删除该套餐吗?", "info")
        .then(() => {
          this.$api.marketing.topDel({ id: row.id }).then(res => {
            if (res.code === 200) {
              handleAlert("套餐已删除", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },

    // add
    add() {
      this.btnContent = "确 定";
      this.isDis = false;
      this.isYuan = null;
      this.isState = false;
      this.type = 1;
      this.AddOREditVisible = true;
      this.addEditForm = {
        name: "",
        companyId: "",
        timeType: "",
        sceneId: "",
        beUseNum: "",
        sort: "",
        state: "",
        period: "周套餐",
        outDay: 7,
        payPrice: "",
        givePrice: "",
        cardBindingBonusPrice: "",
        actualPrice: "",
        unitPrice: "",
        userNum: "",
        consultPrice: ""
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addEditForm.clearValidate();
      });
    },

    // 新增编辑弹框确定按钮
    sure(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // let unitPrice =
          //   this.addEditForm.payPrice /
          //   (this.addEditForm.actualPrice /
          //     this.addEditForm.consultPrice /
          //     7.5);
          // this.addEditForm.unitPrice = unitPrice.toFixed(2);
          if (Number(this.addEditForm.actualPrice) > 5000) {
            handleAlert("实际到账金额不能超过5000元,请重新输入", "error");
            return;
          }
          if (this.type === 1) {
            handleConfirm("确认保存套餐内容吗?", "info")
              .then(() => {
                this.companyIdArr.forEach(v => {
                  if (v.id == this.addEditForm.companyId) {
                    this.companyName = v.companyName;
                  }
                });
                this.$api.marketing
                  .topAdd({
                    beUseNum: this.addEditForm.beUseNum,
                    userNum: this.addEditForm.userNum,
                    consultPrice: this.addEditForm.consultPrice,
                    outDay:
                      this.addEditForm.timeType == "限时套餐"
                        ? this.addEditForm.outDay
                        : null,

                    givePrice: this.addEditForm.givePrice,
                    name: this.addEditForm.name,
                    payPrice: this.addEditForm.payPrice,
                    cardBindingBonusPrice: this.addEditForm
                      .cardBindingBonusPrice,
                    // sceneId:
                    //   this.topSelectActive == 1
                    //     ? this.addEditForm.sceneId.split(",")
                    //     : null,
                    sort: this.addEditForm.sort,
                    state: false,
                    cardType:
                      this.topSelectActive == 1
                        ? 1
                        : this.topSelectActive == 2
                        ? 2
                        : this.topSelectActive == 7
                        ? 7
                        : 3,
                    // type:
                    //   this.topSelectActive === 1
                    //     ? this.addEditForm.cardType
                    //     : 2,
                    // companyId: this.addEditForm.companyId,
                    // companyName: this.companyName,
                    unitPrice: this.addEditForm.unitPrice
                  })
                  .then(res => {
                    if (res.code === 200) {
                      this.addEditForm = {};
                      this.AddOREditVisible = false;
                      this.getList();
                      handleAlert("套餐已新增", "success");
                    }
                  });
              })
              .catch(() => {
                return;
              });
          } else {
            handleConfirm("确认保存套餐内容吗?", "info")
              .then(() => {
                this.companyIdArr.forEach(v => {
                  if (v.id == this.addEditForm.companyId) {
                    this.companyName = v.companyName;
                  }
                });
                this.$api.marketing
                  .topEdit({
                    beUseNum: this.addEditForm.beUseNum,
                    userNum: this.addEditForm.userNum,
                    consultPrice: this.addEditForm.consultPrice,

                    outDay:
                      this.addEditForm.timeType == "限时套餐"
                        ? this.addEditForm.outDay
                        : null,

                    givePrice: this.addEditForm.givePrice,
                    id: this.id,
                    name: this.addEditForm.name,
                    unitPrice: this.addEditForm.unitPrice,
                    payPrice: this.addEditForm.payPrice,
                    cardBindingBonusPrice: this.addEditForm
                      .cardBindingBonusPrice,
                    // sceneId:
                    //   this.topSelectActive == 1
                    //     ? this.addEditForm.sceneId.split(",")
                    //     : null,
                    sort: this.addEditForm.sort,
                    state:
                      this.addEditForm.state == "上架"
                        ? true
                        : this.addEditForm.state == "下架"
                        ? false
                        : this.addEditForm.state == "false"
                        ? false
                        : this.addEditForm.state == "true"
                        ? true
                        : "false"
                    // companyId: this.addEditForm.companyId,
                    // companyName: this.companyName,
                  })
                  .then(res => {
                    if (res.code === 200) {
                      this.addEditForm = {};
                      this.AddOREditVisible = false;
                      this.getList();
                      handleAlert("套餐已修改", "success");
                    }
                  });
              })
              .catch(() => {
                return;
              });
          }
        } else {
          return false;
        }
      });
    },

    // 编辑
    handleEdit(row) {
      if (row.examine == 2) {
        this.isState = true;
        this.btnContent = "确 定";
        this.isYuan = null;
        this.isDis = true;
      } else {
        this.isState = false;
        this.btnContent = "重新提交";
        this.isYuan = 1;
        this.isDis = false;
      }
      this.type = 2;
      this.AddOREditVisible = true;
      this.id = row.id;
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addEditForm.clearValidate();
      });
      this.addEditForm = JSON.parse(JSON.stringify(row));
      if (row.outDay) {
        this.addEditForm.timeType = "限时套餐";
      } else {
        this.addEditForm.timeType = "普通套餐";
      }
      this.addEditForm.period =
        row.outDay === 7
          ? "周套餐"
          : row.outDay === 30
          ? "月套餐"
          : row.outDay === 90
          ? "季套餐"
          : row.outDay === 365
          ? "年套餐"
          : "- -";
      this.addEditForm.actualPrice = (
        Number(this.addEditForm.payPrice) + Number(this.addEditForm.givePrice)
      ).toFixed(2);
      // this.addEditForm.cardType = row.type.toString();
      this.addEditForm.state =
        this.addEditForm.state === true ? "上架" : "下架";
    },

    // 重置
    reset() {
      this.lookForm = { startTime: "", endTime: "" };
      this.getList();
    },

    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },

    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },

    // 弹框关闭清除验证信息
    close() {
      this.addEditForm = {};
    }
  }
};
</script>

<style lang="scss" scoped>
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
/deep/ .topNum .el-form-item__label {
  color: #999b9c !important;
}
/deep/ .topNum .el-input {
  width: 200px;
}
.topNum span {
  color: var(--danger);
  font-size: 10px;
}
.topSelect {
  display: flex;
  align-items: center;
  .div {
    width: 200px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin-right: 30px;
    background: var(--card-bg);
    cursor: pointer;
  }
  .divActive {
    width: 200px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin-right: 30px;
    background: #2049e0;
    color: #fff;
    cursor: pointer;
  }
}

.colorred {
  color: red;
}
</style>
